export default __webpack_public_path__ + "static/media/021-millionaire.118affe2.svg";